import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
};

export type AccessUserPayload = {
  __typename?: 'AccessUserPayload';
  accessToken?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
};

export type ActiveRedemptionsInput = {
  code: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['String']>;
};

export type ActiveRedemptionsPayload = {
  __typename?: 'ActiveRedemptionsPayload';
  data?: Maybe<Array<Maybe<StripeCustomer>>>;
  has_more?: Maybe<Scalars['Boolean']>;
  next_page?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AddFcmTokenInput = {
  platform: PlatFormType;
  token: Scalars['String'];
};

export type AddOrUpdateSecurityPin = {
  securityPin: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AdminRegisterUserInput = {
  fullName: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type AdminUpdatePayload = {
  __typename?: 'AdminUpdatePayload';
  fullName: Scalars['String'];
  id: Scalars['String'];
};

export type ApiList = {
  __typename?: 'ApiList';
  data: Array<SubscriptionDto>;
  has_more?: Maybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type AppliesTo = {
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AppliesToProducts = {
  __typename?: 'AppliesToProducts';
  products: Array<Scalars['String']>;
};

export type AutomaticTax = {
  __typename?: 'AutomaticTax';
  enabled: Scalars['Boolean'];
};

export type BillingThresholds = {
  __typename?: 'BillingThresholds';
  amount_gte: Scalars['Float'];
  reset_billing_cycle_anchor?: Maybe<Scalars['Boolean']>;
};

export type CancellationDetails = {
  __typename?: 'CancellationDetails';
  comment?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type Card = {
  __typename?: 'Card';
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_line1?: Maybe<Scalars['String']>;
  address_line1_check?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_zip?: Maybe<Scalars['String']>;
  address_zip_check?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  last4: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type ChangeCardInput = {
  customerStripeId: Scalars['String'];
  token: Scalars['String'];
};

export type Charge = {
  __typename?: 'Charge';
  amount?: Maybe<Scalars['Int']>;
  created: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  failure_code?: Maybe<Scalars['String']>;
  failure_message?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  object: Scalars['String'];
  paid: Scalars['Boolean'];
  payment_method_details?: Maybe<PaymentMethodDetails>;
  receipt_number?: Maybe<Scalars['String']>;
  receipt_url?: Maybe<Scalars['String']>;
  source?: Maybe<Card>;
  status: Scalars['String'];
};

export type ConfirmWalletPaymentInput = {
  paymentIntentId: Scalars['String'];
};

export type Contact = {
  __typename?: 'Contact';
  createdAt?: Maybe<Scalars['DateTime']>;
  declinedCount?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nickName: Scalars['String'];
  phoneNumber: Scalars['String'];
  phoneType: PhoneType;
  priority: Scalars['Int'];
  status?: Maybe<ContactStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContactOptInInput = {
  optIn: Scalars['Boolean'];
  token: Scalars['String'];
};

export type ContactOptInLinkInput = {
  contactId: Scalars['String'];
};

export enum ContactStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']>;
  applies_to?: Maybe<AppliesToProducts>;
  created: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  duration: Scalars['String'];
  duration_in_months?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  livemode: Scalars['Boolean'];
  max_redemptions?: Maybe<Scalars['Float']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  object: Scalars['String'];
  percent_off?: Maybe<Scalars['Float']>;
  redeem_by?: Maybe<Scalars['Float']>;
  times_redeemed: Scalars['Float'];
  valid: Scalars['Boolean'];
};

export type CouponListInput = {
  ending_before?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  starting_after?: InputMaybe<Scalars['String']>;
};

export type CouponPayload = {
  __typename?: 'CouponPayload';
  amountOff?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type CouponsListPayload = {
  __typename?: 'CouponsListPayload';
  data: Array<Coupon>;
  has_more?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type CreateClientSecretPayload = {
  __typename?: 'CreateClientSecretPayload';
  clientSecret?: Maybe<Scalars['String']>;
};

export type CreateContactInput = {
  contactLimit: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nickName: Scalars['String'];
  phoneNumber: Scalars['String'];
  phoneType?: PhoneType;
};

export type CreateCouponInput = {
  amount_off?: InputMaybe<Scalars['Int']>;
  applies_to?: InputMaybe<AppliesTo>;
  currency?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Duration>;
  duration_in_months?: InputMaybe<Scalars['Float']>;
  expand?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  max_redemptions?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  percent_off?: InputMaybe<Scalars['Float']>;
  redeem_by?: InputMaybe<Scalars['Float']>;
};

export type CreateSocialSourceInput = {
  name: Scalars['String'];
};

export type CreateSubscriptionInput = {
  coupon?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  price: Scalars['String'];
  referrerUserId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type DateFilter = {
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type DeleteContactInput = {
  contactLimit: Scalars['Int'];
  id: Scalars['String'];
  priority: Scalars['Int'];
};

export type DeleteUserInput = {
  userId: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  checkout_session?: Maybe<Scalars['String']>;
  coupon: Coupon;
  id: Scalars['String'];
  object: Scalars['String'];
  start: Scalars['Float'];
};

export type EndBehavior = {
  __typename?: 'EndBehavior';
  missing_payment_method: Scalars['String'];
};

export type Feature = {
  __typename?: 'Feature';
  name: Scalars['String'];
};

export type FetchRecentCallLogInput = {
  timeStamp: Scalars['String'];
};

export type FetchRingMyPhoneLogInput = {
  id: Scalars['String'];
};

export type FetchUserByEmailInput = {
  email: Scalars['String'];
};

export type FetchUsersInput = {
  from?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  orderByName?: InputMaybe<Scalars['Boolean']>;
  paginationOptions: PaginationInput;
  roleType: Array<UserRoles>;
  status?: InputMaybe<Scalars['Float']>;
  subscriptionFilters?: InputMaybe<SubscriptionFiltersInput>;
  to?: InputMaybe<Scalars['String']>;
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']>;
  loginType?: InputMaybe<LoginType>;
};

export type InviteUserInput = {
  email: Scalars['String'];
  roleType: UserRoles;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  email: Scalars['String'];
  roleType?: Maybe<UserRoles>;
};

export type Invoice = {
  __typename?: 'Invoice';
  account_country: Scalars['String'];
  account_name: Scalars['String'];
  amount_due: Scalars['Float'];
  amount_paid: Scalars['Float'];
  amount_remaining: Scalars['Float'];
  attempt_count: Scalars['Float'];
  billing_reason?: Maybe<Scalars['String']>;
  charge?: Maybe<Charge>;
  created: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hosted_invoice_url?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice_pdf?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  object: Scalars['String'];
  paid: Scalars['Boolean'];
  period_end?: Maybe<Scalars['Float']>;
  period_start?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  subtotal: Scalars['Float'];
  subtotal_excluding_tax: Scalars['Float'];
  total: Scalars['Float'];
  total_discount_amounts?: Maybe<Array<TotalDiscountAmount>>;
};

export type InvoiceData = {
  __typename?: 'InvoiceData';
  data?: Maybe<Array<Maybe<Invoice>>>;
  has_more: Scalars['Boolean'];
  url: Scalars['String'];
};

export type InvoiceInput = {
  customer: Scalars['String'];
  ending_before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  starting_after?: InputMaybe<Scalars['String']>;
};

export type IsSubscribed = {
  __typename?: 'IsSubscribed';
  customerStripeId?: Maybe<Scalars['String']>;
  subscriptionCancelled?: Maybe<Scalars['Boolean']>;
};

export enum LoginType {
  Admin = 'ADMIN',
  Portal = 'PORTAL'
}

export type LoginUserInput = {
  email: Scalars['String'];
  loginType?: InputMaybe<LoginType>;
  password: Scalars['String'];
  rememberMe?: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addFcmToken: Scalars['String'];
  addSecurityPin: Scalars['Boolean'];
  adminRegister: User;
  adminUpdateCustomerEmail: User;
  changeCard: Card;
  confirmWalletPayment: ConfirmWalletPaymentPayload;
  consumeMobileHandoffToken: AccessUserPayload;
  contactOpt: Scalars['String'];
  createClientSecret: CreateClientSecretPayload;
  createContact: Contact;
  createCoupon: Scalars['Boolean'];
  createSocialSource: SocialSource;
  createSubscription: SubscriptionEntity;
  deactivateUserAccount: User;
  deleteContact: Array<Contact>;
  deleteCoupon: Scalars['Boolean'];
  deleteUser: Scalars['String'];
  forgotPassword: Scalars['Boolean'];
  generateMobileHandoffToken: Scalars['String'];
  inviteUser: Scalars['Boolean'];
  login: AccessUserPayload;
  optOutContact: OptOutPayload;
  register: User;
  removeFcmToken: Scalars['String'];
  removeSocialSource: Scalars['Boolean'];
  removeUser: Scalars['Boolean'];
  resendOptInLink: Scalars['String'];
  resendVerificationEmail: Scalars['Boolean'];
  sendOtp: SendOtpPayload;
  sendOtpV2: SendOtpPayload;
  superAdminUpdateAdmin: AdminUpdatePayload;
  swapContactPriority: Array<Contact>;
  updateCardDetail: Card;
  updateContact: Contact;
  updateCoupon: Scalars['Boolean'];
  updateFreePlan: UpdatePlanPayload;
  updateNotificationStatus: Scalars['String'];
  updateSocialSource: SocialSource;
  updateSubscriptionPlan: SubscriptionDto;
  updateUser: User;
  updateUserPassword: User;
  updateUserSocialSource: UserSocialSource;
  updateUserStatusFromAdmin: User;
  userRingMyPhoneSettings: Scalars['String'];
  verifyEmailToken: InviteUserPayload;
  verifyInvitationEmailToken: Scalars['Boolean'];
  verifyOtp: VerifyOtpPayload;
  verifyResetPasswordToken: Scalars['Boolean'];
  verifyResetPasswordTokenAndSetPassword: Scalars['Boolean'];
};


export type MutationAddFcmTokenArgs = {
  addFcmTokenInput: AddFcmTokenInput;
};


export type MutationAddSecurityPinArgs = {
  addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin;
};


export type MutationAdminRegisterArgs = {
  registerAdminUserInput: AdminRegisterUserInput;
};


export type MutationAdminUpdateCustomerEmailArgs = {
  email: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationChangeCardArgs = {
  changeCardInput: ChangeCardInput;
};


export type MutationConfirmWalletPaymentArgs = {
  confirmWalletPaymentInput: ConfirmWalletPaymentInput;
};


export type MutationConsumeMobileHandoffTokenArgs = {
  token: Scalars['String'];
};


export type MutationContactOptArgs = {
  input: ContactOptInInput;
};


export type MutationCreateClientSecretArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationCreateContactArgs = {
  createContactInput: CreateContactInput;
};


export type MutationCreateCouponArgs = {
  createCouponInput: CreateCouponInput;
};


export type MutationCreateSocialSourceArgs = {
  createSocialSourceInput: CreateSocialSourceInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationDeleteContactArgs = {
  deleteContactInput: DeleteContactInput;
};


export type MutationDeleteCouponArgs = {
  deleteCouponInput: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationInviteUserArgs = {
  InviteUserInput: InviteUserInput;
};


export type MutationLoginArgs = {
  loginUser: LoginUserInput;
};


export type MutationOptOutContactArgs = {
  optOutContactInput: OptOutContactInput;
};


export type MutationRegisterArgs = {
  registerUserInput: RegisterUserInput;
};


export type MutationRemoveSocialSourceArgs = {
  input: RemoveSocialSourceInput;
};


export type MutationRemoveUserArgs = {
  id: Scalars['String'];
};


export type MutationResendOptInLinkArgs = {
  contactOptInInput: ContactOptInLinkInput;
};


export type MutationResendVerificationEmailArgs = {
  resendEmailInput: ResendEmailInput;
};


export type MutationSendOtpArgs = {
  sendOtpInput: SendOtpInput;
};


export type MutationSendOtpV2Args = {
  sendOtpInputV2: SendOtpInput;
};


export type MutationSuperAdminUpdateAdminArgs = {
  superAdminUpdateAdminInput: SuperAdminUpdateAdminInput;
};


export type MutationSwapContactPriorityArgs = {
  swapContactPriorityInput: SwapPriorityInput;
};


export type MutationUpdateCardDetailArgs = {
  updateCardDetails: UpdateCardDetailInput;
};


export type MutationUpdateContactArgs = {
  updateContactInput: UpdateContactInput;
};


export type MutationUpdateCouponArgs = {
  updateCouponInput: UpdateCouponInput;
};


export type MutationUpdateFreePlanArgs = {
  updatePlanInput: UpdatePlanInput;
};


export type MutationUpdateNotificationStatusArgs = {
  updateNotificationInput: UpdateNotificationInput;
};


export type MutationUpdateSocialSourceArgs = {
  updateSocialSourceInput: UpdateSocialSourceInput;
};


export type MutationUpdateSubscriptionPlanArgs = {
  updateSubscriptionPlanInput: UpdateSubscriptionPlan;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserPasswordInput: UpdateUserPasswordInput;
};


export type MutationUpdateUserSocialSourceArgs = {
  input: UpdateUserSocialSourceInput;
};


export type MutationUpdateUserStatusFromAdminArgs = {
  status: Scalars['Float'];
  userId: Scalars['String'];
};


export type MutationUserRingMyPhoneSettingsArgs = {
  userRingMyPhoneInput: UserRingMyPhoneInput;
};


export type MutationVerifyEmailTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyInvitationEmailTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyOtpArgs = {
  verifyOtpInput: OtpVerifyInput;
};


export type MutationVerifyResetPasswordTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyResetPasswordTokenAndSetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};

export enum NotificationType {
  AppNotification = 'APP_NOTIFICATION',
  PhoneCall = 'PHONE_CALL'
}

export type OptOutContactInput = {
  token: Scalars['String'];
};

export type OptOutPayload = {
  __typename?: 'OptOutPayload';
  message: Scalars['String'];
};

export enum OtpVerification {
  OtpVerify = 'OTP_VERIFY',
  PhoneVerify = 'PHONE_VERIFY',
  TPinVerify = 'T_PIN_VERIFY'
}

export type OtpVerifyInput = {
  otp: Scalars['String'];
  otpType?: OtpVerification;
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaginationPayload = {
  __typename?: 'PaginationPayload';
  hasMore: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PauseCollection = {
  __typename?: 'PauseCollection';
  behavior: Scalars['String'];
  resumes_at?: Maybe<Scalars['Float']>;
};

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  card?: Maybe<Card>;
};

export type PendingInvoiceItemInterval = {
  __typename?: 'PendingInvoiceItemInterval';
  interval: Scalars['String'];
};

export enum PhoneType {
  Cell = 'CELL',
  LandLine = 'LAND_LINE'
}

export type Plan = {
  __typename?: 'Plan';
  active: Scalars['Boolean'];
  aggregate_usage?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  amount_decimal?: Maybe<Scalars['String']>;
  billing_scheme: Scalars['String'];
  created: Scalars['Float'];
  currency: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  nickname?: Maybe<Scalars['String']>;
  object: Scalars['String'];
  product: Scalars['String'];
  productDetails?: Maybe<Product>;
  tiers?: Maybe<Array<Tier>>;
  tiers_mode?: Maybe<Scalars['String']>;
  transform_usage?: Maybe<TransformUsage>;
  trial_period_days?: Maybe<Scalars['Float']>;
  usage_type: Scalars['String'];
};

export type PlanPayload = {
  __typename?: 'PlanPayload';
  data: Array<Plan>;
  trialEnded?: Maybe<Scalars['Boolean']>;
};

/** device type of fcm token */
export enum PlatFormType {
  Andriod = 'ANDRIOD',
  Ios = 'IOS'
}

export type Product = {
  __typename?: 'Product';
  id: Scalars['String'];
  marketing_features?: Maybe<Array<Feature>>;
  name: Scalars['String'];
};

export type ProductsByIdInput = {
  ids: Array<Scalars['String']>;
};

export type ProductsPayload = {
  __typename?: 'ProductsPayload';
  data?: Maybe<Array<Maybe<Product>>>;
};

export type Query = {
  __typename?: 'Query';
  fetchActiveRedemptions: ActiveRedemptionsPayload;
  fetchAllContacts: Array<Contact>;
  fetchAllOptedOutContacts: Array<Contact>;
  fetchAllUsers: UserPayload;
  fetchCardDetails?: Maybe<Card>;
  fetchContactsByUserId: Array<Contact>;
  fetchCouponsList: CouponsListPayload;
  fetchCustomerInvoices: InvoiceData;
  fetchDefaultMessage: Scalars['String'];
  fetchFreePlan: Plan;
  fetchPlan: PlanPayload;
  fetchProducts: ProductsPayload;
  fetchProductsByIds: ProductsPayload;
  fetchRecentCallLog: RingMyPhoneLogs;
  fetchRingMyPhoneLog: RingMyPhoneLogs;
  fetchSocialSources: SocialSourcePayload;
  fetchUser: User;
  fetchUserByEmail: UserByEmailPayload;
  fetchUserUsageDetails: UserUsageDetailsResponse;
  fetchVipContact?: Maybe<Contact>;
  getSubscriptionDetail: ApiList;
  me: User;
  recentRingMyPhoneLogs: RingMyPhoneCallLogPayload;
  referralsByAssignee: ReferralsPayload;
  retrieveCoupon: CouponPayload;
  retrieveCouponPublic: CouponPayload;
  ringMyPhone: RingMyPhoneLogs;
  validateTokenContact: ValidateContactPayload;
  validateTokenOptIn: ValidateContactPayload;
};


export type QueryFetchActiveRedemptionsArgs = {
  fetchActiveRedemptionsInput: ActiveRedemptionsInput;
};


export type QueryFetchAllUsersArgs = {
  fetchUsersInput: FetchUsersInput;
};


export type QueryFetchCardDetailsArgs = {
  fetchCardDetailsInput: Scalars['String'];
};


export type QueryFetchContactsByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryFetchCouponsListArgs = {
  fetchCouponsListInput: CouponListInput;
};


export type QueryFetchCustomerInvoicesArgs = {
  customerInvoiceInput: InvoiceInput;
};


export type QueryFetchProductsByIdsArgs = {
  fetchProductsByIdInput: ProductsByIdInput;
};


export type QueryFetchRecentCallLogArgs = {
  fetchRecentCallLogInput: FetchRecentCallLogInput;
};


export type QueryFetchRingMyPhoneLogArgs = {
  fetchRingMyPhoneLogInput: FetchRingMyPhoneLogInput;
};


export type QueryFetchSocialSourcesArgs = {
  input: PaginationInput;
};


export type QueryFetchUserArgs = {
  userId: Scalars['String'];
};


export type QueryFetchUserByEmailArgs = {
  fetchUserByEmailInput: FetchUserByEmailInput;
};


export type QueryFetchUserUsageDetailsArgs = {
  userId: Scalars['String'];
};


export type QueryGetSubscriptionDetailArgs = {
  customerStripeId: Scalars['String'];
};


export type QueryRecentRingMyPhoneLogsArgs = {
  input: PaginationInput;
};


export type QueryReferralsByAssigneeArgs = {
  input: ReferralsByAssigneeInput;
};


export type QueryRetrieveCouponArgs = {
  retrieveCouponInput: Scalars['String'];
};


export type QueryRetrieveCouponPublicArgs = {
  retrieveCouponInput: Scalars['String'];
};


export type QueryValidateTokenContactArgs = {
  optOutContactInput: OptOutContactInput;
};


export type QueryValidateTokenOptInArgs = {
  optOutContactInput: OptOutContactInput;
};

export type ReferralsByAssigneeInput = {
  /** Required unless token is provided. */
  assigneeUserId?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
  /** Pass a referral ID to get its direct children. Omit to get root-level referrals. */
  parentReferralId?: InputMaybe<Scalars['ID']>;
  /** Browse the referral tree rooted at this user, regardless of assignee. Takes precedence over parentReferralId for the starting node. */
  rootUserId?: InputMaybe<Scalars['ID']>;
  /** Filter by referred user email (partial match). */
  searchEmail?: InputMaybe<Scalars['String']>;
  /** Search by promo code token. Finds the referral with this code and its subtree. */
  token?: InputMaybe<Scalars['String']>;
};

export type ReferralsPayload = {
  __typename?: 'ReferralsPayload';
  pagination?: Maybe<PaginationPayload>;
  referrals?: Maybe<Array<Maybe<UserReferral>>>;
};

export type RegisterUserInput = {
  captchaToken: Scalars['String'];
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  fullName: Scalars['String'];
  password: Scalars['String'];
  socialSourceId?: InputMaybe<Scalars['String']>;
};

export type RemoveSocialSourceInput = {
  id: Scalars['String'];
};

export type ResendEmailInput = {
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RingMyPhoneCallLogPayload = {
  __typename?: 'RingMyPhoneCallLogPayload';
  pagination?: Maybe<PaginationPayload>;
  ringMyPhoneLogs?: Maybe<Array<RingMyPhoneLogs>>;
};

export type RingMyPhoneLogs = {
  __typename?: 'RingMyPhoneLogs';
  callSid?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  notificationType?: Maybe<NotificationType>;
  phone?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  ringMyPhoneStatus?: Maybe<RingMyPhoneStatus>;
  status?: Maybe<TwillioCallStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum RingMyPhoneStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED'
}

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  role: UserRoles;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SendOtpInput = {
  otpType?: OtpVerification;
  phoneNumber: Scalars['String'];
};

export type SendOtpPayload = {
  __typename?: 'SendOtpPayload';
  code?: Maybe<Scalars['String']>;
  sendOtp: Scalars['Boolean'];
};

export type SocialSource = {
  __typename?: 'SocialSource';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  totalUsersReached?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SocialSourcePayload = {
  __typename?: 'SocialSourcePayload';
  pagination?: Maybe<PaginationPayload>;
  socialSources?: Maybe<Array<SocialSource>>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<Address>;
  balance?: Maybe<Scalars['Float']>;
  created: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
  default_source?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  delinquent?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  livemode: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  object: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type SubscriptionDto = {
  __typename?: 'SubscriptionDto';
  application?: Maybe<Scalars['String']>;
  application_fee_percent?: Maybe<Scalars['Float']>;
  automatic_tax: AutomaticTax;
  billing_cycle_anchor: Scalars['Float'];
  billing_thresholds?: Maybe<BillingThresholds>;
  cancel_at?: Maybe<Scalars['Float']>;
  cancel_at_period_end: Scalars['Boolean'];
  canceled_at?: Maybe<Scalars['Float']>;
  cancellation_details?: Maybe<CancellationDetails>;
  collection_method: Scalars['String'];
  created: Scalars['Float'];
  currency: Scalars['String'];
  current_period_end: Scalars['Float'];
  current_period_start: Scalars['Float'];
  customer: Scalars['String'];
  days_until_due?: Maybe<Scalars['Float']>;
  default_payment_method?: Maybe<Scalars['String']>;
  default_source?: Maybe<Scalars['String']>;
  default_tax_rates?: Maybe<Array<TaxRate>>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  ended_at?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  items: SubscriptionItemDto;
  latest_invoice?: Maybe<Scalars['String']>;
  livemode: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['Float']>;
  object: Scalars['String'];
  on_behalf_of?: Maybe<Scalars['String']>;
  pause_collection?: Maybe<PauseCollection>;
  pending_invoice_item_interval?: Maybe<PendingInvoiceItemInterval>;
  schedule?: Maybe<Scalars['String']>;
  start_date: Scalars['Float'];
  status: Scalars['String'];
  transfer_data?: Maybe<TransferData>;
  trial_end?: Maybe<Scalars['Float']>;
  trial_settings?: Maybe<TrialSettings>;
  trial_start?: Maybe<Scalars['Float']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  callDuration?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** customer stripe ID */
  customerStripeId: Scalars['String'];
  getSubscriptionDetails?: Maybe<ApiList>;
  id: Scalars['ID'];
  subscriptionExpired?: Maybe<SubscriptionExpirationPayload>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionExpirationPayload = {
  __typename?: 'SubscriptionExpirationPayload';
  expirationDate?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  subscribedOnDate?: Maybe<Scalars['String']>;
};

export type SubscriptionFiltersInput = {
  created?: InputMaybe<DateFilter>;
  current_period_end?: InputMaybe<DateFilter>;
  ending_before?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  starting_after?: InputMaybe<Scalars['String']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  billing_thresholds?: Maybe<BillingThresholds>;
  created: Scalars['Float'];
  id: Scalars['String'];
  object: Scalars['String'];
  plan: Plan;
  quantity?: Maybe<Scalars['Float']>;
  subscription: Scalars['String'];
};

export type SubscriptionItemDto = {
  __typename?: 'SubscriptionItemDTO';
  data: Array<SubscriptionItem>;
  has_more: Scalars['Boolean'];
  object: Scalars['String'];
  total_count: Scalars['Float'];
  url: Scalars['String'];
};

export type SuperAdminUpdateAdminInput = {
  fullName: Scalars['String'];
  userId: Scalars['String'];
};

export type SwapPriorityInput = {
  idOne: Scalars['String'];
  idTwo: Scalars['String'];
  priorityOne: Scalars['Int'];
  priorityTwo: Scalars['Int'];
};

export type TaxRate = {
  __typename?: 'TaxRate';
  active: Scalars['Boolean'];
  country: Scalars['String'];
  created: Scalars['Float'];
  description: Scalars['String'];
  display_name: Scalars['String'];
  effective_percentage: Scalars['Float'];
  id: Scalars['String'];
  inclusive: Scalars['Boolean'];
  jurisdiction: Scalars['String'];
  livemode: Scalars['Boolean'];
  object: Scalars['String'];
  percentage: Scalars['Float'];
  state: Scalars['String'];
};

export type Tier = {
  __typename?: 'Tier';
  flat_amount?: Maybe<Scalars['Int']>;
  flat_amount_decimal?: Maybe<Scalars['String']>;
  unit_amount?: Maybe<Scalars['Float']>;
  unit_amount_decimal?: Maybe<Scalars['String']>;
  up_to?: Maybe<Scalars['Float']>;
};

export type TotalDiscountAmount = {
  __typename?: 'TotalDiscountAmount';
  amount: Scalars['Float'];
  discount: Scalars['String'];
};

export type TransferData = {
  __typename?: 'TransferData';
  amount_percent: Scalars['Float'];
  destination: Scalars['String'];
};

export type TransformUsage = {
  __typename?: 'TransformUsage';
  divide_by: Scalars['Float'];
  round: Scalars['String'];
};

export type TrialSettings = {
  __typename?: 'TrialSettings';
  end_behavior: EndBehavior;
};

export enum TwillioCallStatus {
  Busy = 'BUSY',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NoAnswer = 'NO_ANSWER',
  Queued = 'QUEUED',
  Ringing = 'RINGING'
}

export type UpdateCardDetailInput = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_holder_type?: InputMaybe<Scalars['String']>;
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_line1?: InputMaybe<Scalars['String']>;
  address_line2?: InputMaybe<Scalars['String']>;
  address_state?: InputMaybe<Scalars['String']>;
  address_zip?: InputMaybe<Scalars['String']>;
  customerStripeId: Scalars['String'];
  exp_month?: InputMaybe<Scalars['String']>;
  exp_year?: InputMaybe<Scalars['String']>;
};

export type UpdateContactInput = {
  contactLimit?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nickName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneType?: InputMaybe<PhoneType>;
};

export type UpdateCouponInput = {
  /** Coupon id/code to update. */
  code: Scalars['String'];
  /** Key-value metadata (e.g. salesPersonId, phoneNumber). Fully editable in Stripe; pass the full metadata object to set/replace. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Display name for the coupon (editable in Stripe). */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationInput = {
  id: Scalars['String'];
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
};

export type UpdatePlanInput = {
  id: Scalars['String'];
  trial_period_days: Scalars['Int'];
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  id: Scalars['String'];
  trial_period_days: Scalars['Int'];
};

export type UpdateSocialSourceInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSubscriptionPlan = {
  description?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  subscriptionId: Scalars['String'];
  subscriptionItemId: Scalars['String'];
};

export type UpdateUserInput = {
  captchaToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailVerified?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  socialSourceId?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPasswordInput = {
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};

export type UpdateUserSocialSourceInput = {
  socialSourceId: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultMessage?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  enablePhoneRinger?: Maybe<Scalars['Boolean']>;
  fcmToken?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSubscribed?: Maybe<IsSubscribed>;
  isTPinAdded?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberSid?: Maybe<Scalars['String']>;
  phoneVerified?: Maybe<Scalars['Boolean']>;
  platform?: Maybe<PlatFormType>;
  ringMyPhoneLogs?: Maybe<Array<Maybe<RingMyPhoneLogs>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  showLogo: Scalars['Boolean'];
  status: UserStatus;
  subscription?: Maybe<SubscriptionEntity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSocialSource?: Maybe<UserSocialSource>;
};

export type UserByEmailPayload = {
  __typename?: 'UserByEmailPayload';
  id: Scalars['String'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  pagination?: Maybe<PaginationPayload>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserReferral = {
  __typename?: 'UserReferral';
  assigneeUser?: Maybe<User>;
  assigneeUserId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directChildCount?: Maybe<Scalars['Float']>;
  freeMonthsAtApply?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  promoCode: Scalars['String'];
  referredUser?: Maybe<User>;
  referredUserId?: Maybe<Scalars['ID']>;
  referrerUser?: Maybe<User>;
  referrerUserId?: Maybe<Scalars['ID']>;
  rootPromoCodeId?: Maybe<Scalars['String']>;
  totalDescendantCount?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserRingMyPhoneInput = {
  defaultMessage: Scalars['Boolean'];
  enablePhoneRinger: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  showLogo: Scalars['Boolean'];
};

export type UserSocialSource = {
  __typename?: 'UserSocialSource';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  socialSource?: Maybe<SocialSource>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The user status */
export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING'
}

export type UserUsageDetailsResponse = {
  __typename?: 'UserUsageDetailsResponse';
  currentMonthUsage?: Maybe<Scalars['Int']>;
  overAllUsage?: Maybe<Scalars['Int']>;
  user: User;
};

export type ValidateContactPayload = {
  __typename?: 'ValidateContactPayload';
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type VerifyOtpPayload = {
  __typename?: 'VerifyOtpPayload';
  otpVerified: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ConfirmWalletPaymentPayload = {
  __typename?: 'confirmWalletPaymentPayload';
  customerStripeId: Scalars['String'];
};

export enum Duration {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

/** The user role assigned */
export enum UserRoles {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Sales = 'SALES',
  SuperAdmin = 'SUPER_ADMIN'
}

export type LoginMutationVariables = Exact<{
  loginUser: LoginUserInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccessUserPayload', accessToken?: string | null } };

export type RegisterMutationVariables = Exact<{
  registerUserInput: RegisterUserInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'User', email: string, emailVerified: boolean, fullName?: string | null, phoneNumber?: string | null, status: UserStatus, roles?: Array<{ __typename?: 'Role', role: UserRoles } | null> | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type VerifyResetPasswordTokenAndSetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type VerifyResetPasswordTokenAndSetPasswordMutation = { __typename?: 'Mutation', verifyResetPasswordTokenAndSetPassword: boolean };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, createdAt?: any | null, updatedAt?: any | null, fullName?: string | null, status: UserStatus, email: string, emailVerified: boolean, phoneVerified?: boolean | null, phoneNumber?: string | null, phoneNumberSid?: string | null, isTPinAdded?: boolean | null, fcmToken?: string | null, defaultMessage?: boolean | null, message?: string | null, enablePhoneRinger?: boolean | null, showLogo: boolean, roles?: Array<{ __typename?: 'Role', role: UserRoles, id: string, createdAt?: any | null, updatedAt?: any | null } | null> | null, isSubscribed?: { __typename?: 'IsSubscribed', customerStripeId?: string | null, subscriptionCancelled?: boolean | null } | null, userSocialSource?: { __typename?: 'UserSocialSource', id: string, socialSource?: { __typename?: 'SocialSource', id: string, name?: string | null } | null } | null } };

export type VerifyEmailTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailTokenMutation = { __typename?: 'Mutation', verifyEmailToken: { __typename?: 'InviteUserPayload', email: string, roleType?: UserRoles | null } };

export type ConsumeMobileHandoffTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConsumeMobileHandoffTokenMutation = { __typename?: 'Mutation', consumeMobileHandoffToken: { __typename?: 'AccessUserPayload', accessToken?: string | null } };

export type RetrieveCouponPublicQueryVariables = Exact<{
  retrieveCouponInput: Scalars['String'];
}>;


export type RetrieveCouponPublicQuery = { __typename?: 'Query', retrieveCouponPublic: { __typename?: 'CouponPayload', amountOff?: number | null, name?: string | null, percentOff?: number | null, products?: Array<string> | null, description?: string | null, expirationDate?: string | null, isActive?: boolean | null, title?: string | null } };

export type CreateContactMutationVariables = Exact<{
  createContactInput: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, createdAt?: any | null, updatedAt?: any | null, phoneNumber: string, priority: number, nickName: string, name: string, phoneType: PhoneType, email?: string | null } };

export type FetchAllContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllContactsQuery = { __typename?: 'Query', fetchAllContacts: Array<{ __typename?: 'Contact', id: string, createdAt?: any | null, updatedAt?: any | null, phoneNumber: string, priority: number, nickName: string, name: string, phoneType: PhoneType, email?: string | null }> };

export type FetchAllOptedOutContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllOptedOutContactsQuery = { __typename?: 'Query', fetchAllOptedOutContacts: Array<{ __typename?: 'Contact', id: string, createdAt?: any | null, updatedAt?: any | null, phoneNumber: string, priority: number, nickName: string, name: string, phoneType: PhoneType, email?: string | null }> };

export type UpdateContactMutationVariables = Exact<{
  updateContactInput: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, createdAt?: any | null, updatedAt?: any | null, phoneNumber: string, nickName: string, name: string, phoneType: PhoneType, email?: string | null, priority: number } };

export type SwapContactPriorityMutationVariables = Exact<{
  swapContactPriorityInput: SwapPriorityInput;
}>;


export type SwapContactPriorityMutation = { __typename?: 'Mutation', swapContactPriority: Array<{ __typename?: 'Contact', updatedAt?: any | null, priority: number, phoneNumber: string, phoneType: PhoneType, nickName: string, name: string, id: string, createdAt?: any | null, email?: string | null }> };

export type GetSubscriptionDetailQueryVariables = Exact<{
  customerStripeId: Scalars['String'];
}>;


export type GetSubscriptionDetailQuery = { __typename?: 'Query', getSubscriptionDetail: { __typename?: 'ApiList', data: Array<{ __typename?: 'SubscriptionDto', application?: string | null, application_fee_percent?: number | null, billing_cycle_anchor: number, cancel_at?: number | null, cancel_at_period_end: boolean, canceled_at?: number | null, created: number, default_payment_method?: string | null, default_source?: string | null, description?: string | null, ended_at?: number | null, id: string, latest_invoice?: string | null, livemode: boolean, next_pending_invoice_item_invoice?: number | null, object: string, on_behalf_of?: string | null, schedule?: string | null, start_date: number, status: string, trial_end?: number | null, trial_start?: number | null, current_period_end: number, automatic_tax: { __typename?: 'AutomaticTax', enabled: boolean }, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, cancellation_details?: { __typename?: 'CancellationDetails', comment?: string | null, feedback?: string | null, reason?: string | null } | null, default_tax_rates?: Array<{ __typename?: 'TaxRate', active: boolean, country: string, created: number, description: string, display_name: string, effective_percentage: number, id: string, inclusive: boolean, jurisdiction: string, livemode: boolean, object: string, percentage: number, state: string }> | null, items: { __typename?: 'SubscriptionItemDTO', data: Array<{ __typename?: 'SubscriptionItem', created: number, id: string, object: string, quantity?: number | null, subscription: string, plan: { __typename?: 'Plan', nickname?: string | null, amount?: number | null, product: string, metadata?: any | null, interval: string, id: string, created: number, active: boolean, aggregate_usage?: string | null, amount_decimal?: string | null, billing_scheme: string, currency: string, object: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, productDetails?: { __typename?: 'Product', id: string, name: string, marketing_features?: Array<{ __typename?: 'Feature', name: string }> | null } | null, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null } }> }, pause_collection?: { __typename?: 'PauseCollection', behavior: string, resumes_at?: number | null } | null, pending_invoice_item_interval?: { __typename?: 'PendingInvoiceItemInterval', interval: string } | null, transfer_data?: { __typename?: 'TransferData', amount_percent: number, destination: string } | null, trial_settings?: { __typename?: 'TrialSettings', end_behavior: { __typename?: 'EndBehavior', missing_payment_method: string } } | null }> } };

export type DeleteContactMutationVariables = Exact<{
  deleteContactInput: DeleteContactInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: Array<{ __typename?: 'Contact', id: string, priority: number }> };

export type OptOutContactMutationVariables = Exact<{
  optOutContactInput: OptOutContactInput;
}>;


export type OptOutContactMutation = { __typename?: 'Mutation', optOutContact: { __typename?: 'OptOutPayload', message: string } };

export type ValidateTokenContactQueryVariables = Exact<{
  optOutContactInput: OptOutContactInput;
}>;


export type ValidateTokenContactQuery = { __typename?: 'Query', validateTokenContact: { __typename?: 'ValidateContactPayload', phoneNo: string, name: string } };

export type RingMyPhoneQueryVariables = Exact<{ [key: string]: never; }>;


export type RingMyPhoneQuery = { __typename?: 'Query', ringMyPhone: { __typename?: 'RingMyPhoneLogs', id: string, ringMyPhoneStatus?: RingMyPhoneStatus | null, longitude?: string | null, latitude?: string | null, notificationType?: NotificationType | null, status?: TwillioCallStatus | null } };

export type RecentRingMyPhoneLogsQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type RecentRingMyPhoneLogsQuery = { __typename?: 'Query', recentRingMyPhoneLogs: { __typename?: 'RingMyPhoneCallLogPayload', ringMyPhoneLogs?: Array<{ __typename?: 'RingMyPhoneLogs', id: string, status?: TwillioCallStatus | null, notificationType?: NotificationType | null, ringMyPhoneStatus?: RingMyPhoneStatus | null, createdAt?: any | null, longitude?: string | null, latitude?: string | null, price?: number | null, phone?: string | null }> | null, pagination?: { __typename?: 'PaginationPayload', hasMore: boolean, totalCount?: number | null, totalPages?: number | null, page?: number | null, limit?: number | null } | null } };

export type FetchVipContactQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchVipContactQuery = { __typename?: 'Query', fetchVipContact?: { __typename?: 'Contact', name: string, phoneNumber: string } | null };

export type UserRingMyPhoneSettingsMutationVariables = Exact<{
  UserRingMyPhoneInput: UserRingMyPhoneInput;
}>;


export type UserRingMyPhoneSettingsMutation = { __typename?: 'Mutation', userRingMyPhoneSettings: string };

export type FetchRingMyPhoneLogQueryVariables = Exact<{
  FetchRingMyPhoneLogInput: FetchRingMyPhoneLogInput;
}>;


export type FetchRingMyPhoneLogQuery = { __typename?: 'Query', fetchRingMyPhoneLog: { __typename?: 'RingMyPhoneLogs', id: string, status?: TwillioCallStatus | null, notificationType?: NotificationType | null, ringMyPhoneStatus?: RingMyPhoneStatus | null, latitude?: string | null, longitude?: string | null, createdAt?: any | null } };

export type FetchRecentCallLogQueryVariables = Exact<{
  fetchRecentCallLogInput: FetchRecentCallLogInput;
}>;


export type FetchRecentCallLogQuery = { __typename?: 'Query', fetchRecentCallLog: { __typename?: 'RingMyPhoneLogs', id: string, status?: TwillioCallStatus | null, notificationType?: NotificationType | null, ringMyPhoneStatus?: RingMyPhoneStatus | null } };

export type FetchDefaultMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDefaultMessageQuery = { __typename?: 'Query', fetchDefaultMessage: string };

export type ValidateTokenOptInQueryVariables = Exact<{
  optOutContactInput: OptOutContactInput;
}>;


export type ValidateTokenOptInQuery = { __typename?: 'Query', validateTokenOptIn: { __typename?: 'ValidateContactPayload', name: string, phoneNo: string } };

export type ContactOptMutationVariables = Exact<{
  input: ContactOptInInput;
}>;


export type ContactOptMutation = { __typename?: 'Mutation', contactOpt: string };

export type SendOtpMutationVariables = Exact<{
  sendOtpInput: SendOtpInput;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOtp: { __typename?: 'SendOtpPayload', code?: string | null, sendOtp: boolean } };

export type SendOtpV2MutationVariables = Exact<{
  sendOtpInputV2: SendOtpInput;
}>;


export type SendOtpV2Mutation = { __typename?: 'Mutation', sendOtpV2: { __typename?: 'SendOtpPayload', code?: string | null, sendOtp: boolean } };

export type FetchPhoneVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPhoneVerifiedQuery = { __typename?: 'Query', me: { __typename?: 'User', phoneVerified?: boolean | null, phoneNumber?: string | null, phoneNumberSid?: string | null } };

export type VerifyOtpMutationVariables = Exact<{
  verifyOtpInput: OtpVerifyInput;
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp: { __typename?: 'VerifyOtpPayload', phoneNumber?: string | null } };

export type AddSecurityPinMutationVariables = Exact<{
  addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin;
}>;


export type AddSecurityPinMutation = { __typename?: 'Mutation', addSecurityPin: boolean };

export type FetchPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPlanQuery = { __typename?: 'Query', fetchPlan: { __typename?: 'PlanPayload', trialEnded?: boolean | null, data: Array<{ __typename?: 'Plan', active: boolean, aggregate_usage?: string | null, amount?: number | null, amount_decimal?: string | null, billing_scheme: string, created: number, currency: string, id: string, interval: string, metadata?: any | null, nickname?: string | null, object: string, product: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, productDetails?: { __typename?: 'Product', id: string, name: string, marketing_features?: Array<{ __typename?: 'Feature', name: string }> | null } | null, tiers?: Array<{ __typename?: 'Tier', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null }> } };

export type RetrieveCouponQueryVariables = Exact<{
  retrieveCouponInput: Scalars['String'];
}>;


export type RetrieveCouponQuery = { __typename?: 'Query', retrieveCoupon: { __typename?: 'CouponPayload', amountOff?: number | null, name?: string | null, percentOff?: number | null, products?: Array<string> | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionEntity', customerStripeId: string } };

export type UpdateSubscriptionPlanMutationVariables = Exact<{
  updateSubscriptionPlanInput: UpdateSubscriptionPlan;
}>;


export type UpdateSubscriptionPlanMutation = { __typename?: 'Mutation', updateSubscriptionPlan: { __typename?: 'SubscriptionDto', application?: string | null, application_fee_percent?: number | null, billing_cycle_anchor: number, cancel_at?: number | null, cancel_at_period_end: boolean, canceled_at?: number | null, created: number, default_payment_method?: string | null, default_source?: string | null, description?: string | null, ended_at?: number | null, id: string, latest_invoice?: string | null, livemode: boolean, next_pending_invoice_item_invoice?: number | null, object: string, on_behalf_of?: string | null, schedule?: string | null, start_date: number, status: string, trial_end?: number | null, trial_start?: number | null, automatic_tax: { __typename?: 'AutomaticTax', enabled: boolean }, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, cancellation_details?: { __typename?: 'CancellationDetails', comment?: string | null, feedback?: string | null, reason?: string | null } | null, default_tax_rates?: Array<{ __typename?: 'TaxRate', active: boolean, country: string, created: number, description: string, display_name: string, effective_percentage: number, id: string, inclusive: boolean, jurisdiction: string, livemode: boolean, object: string, percentage: number, state: string }> | null, items: { __typename?: 'SubscriptionItemDTO', data: Array<{ __typename?: 'SubscriptionItem', created: number, id: string, object: string, quantity?: number | null, subscription: string, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, plan: { __typename?: 'Plan', active: boolean, aggregate_usage?: string | null, amount?: number | null, amount_decimal?: string | null, billing_scheme: string, created: number, currency: string, id: string, interval: string, metadata?: any | null, nickname?: string | null, object: string, product: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null } }> }, pause_collection?: { __typename?: 'PauseCollection', behavior: string, resumes_at?: number | null } | null, pending_invoice_item_interval?: { __typename?: 'PendingInvoiceItemInterval', interval: string } | null, transfer_data?: { __typename?: 'TransferData', amount_percent: number, destination: string } | null, trial_settings?: { __typename?: 'TrialSettings', end_behavior: { __typename?: 'EndBehavior', missing_payment_method: string } } | null } };

export type CreateClientSecretMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
}>;


export type CreateClientSecretMutation = { __typename?: 'Mutation', createClientSecret: { __typename?: 'CreateClientSecretPayload', clientSecret?: string | null } };

export type ConfirmWalletPaymentMutationVariables = Exact<{
  confirmWalletPaymentInput: ConfirmWalletPaymentInput;
}>;


export type ConfirmWalletPaymentMutation = { __typename?: 'Mutation', confirmWalletPayment: { __typename?: 'confirmWalletPaymentPayload', customerStripeId: string } };

export type UpdateNameMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateNameMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', fullName?: string | null } };

export type UpdateEmailMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', email: string } };

export type UpdateUserPasswordMutationVariables = Exact<{
  updateUserPasswordInput: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id: string } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', phoneNumber?: string | null } };

export type DeactivateUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateUserAccountMutation = { __typename?: 'Mutation', deactivateUserAccount: { __typename?: 'User', status: UserStatus } };

export type UpdateCardDetailMutationVariables = Exact<{
  updateCardDetails: UpdateCardDetailInput;
}>;


export type UpdateCardDetailMutation = { __typename?: 'Mutation', updateCardDetail: { __typename?: 'Card', address_city?: string | null, address_country?: string | null, address_line1?: string | null, address_line2?: string | null, address_state?: string | null, address_zip?: string | null, name?: string | null } };

export type FetchSocialSourcesQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type FetchSocialSourcesQuery = { __typename?: 'Query', fetchSocialSources: { __typename?: 'SocialSourcePayload', pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, limit?: number | null, totalPages?: number | null } | null, socialSources?: Array<{ __typename?: 'SocialSource', id: string, name?: string | null, totalUsersReached?: number | null }> | null } };

export type UpdateUserSocialSourceMutationVariables = Exact<{
  input: UpdateUserSocialSourceInput;
}>;


export type UpdateUserSocialSourceMutation = { __typename?: 'Mutation', updateUserSocialSource: { __typename?: 'UserSocialSource', id: string, socialSource?: { __typename?: 'SocialSource', id: string, name?: string | null } | null } };

export type UpdateUserStatusFromAdminMutationVariables = Exact<{
  status: Scalars['Float'];
  userId: Scalars['String'];
}>;


export type UpdateUserStatusFromAdminMutation = { __typename?: 'Mutation', updateUserStatusFromAdmin: { __typename?: 'User', createdAt?: any | null, email: string, emailVerified: boolean, fullName?: string | null, id: string, isTPinAdded?: boolean | null, phoneNumber?: string | null, status: UserStatus, updatedAt?: any | null, isSubscribed?: { __typename?: 'IsSubscribed', customerStripeId?: string | null } | null, roles?: Array<{ __typename?: 'Role', createdAt?: any | null, id: string, role: UserRoles, updatedAt?: any | null } | null> | null } };

export type FetchCustomerInvoicesQueryVariables = Exact<{
  customerInvoiceInput: InvoiceInput;
}>;


export type FetchCustomerInvoicesQuery = { __typename?: 'Query', fetchCustomerInvoices: { __typename?: 'InvoiceData', has_more: boolean, url: string, data?: Array<{ __typename?: 'Invoice', account_country: string, account_name: string, amount_due: number, amount_paid: number, amount_remaining: number, attempt_count: number, billing_reason?: string | null, description?: string | null, created: number, currency?: string | null, customer?: string | null, customer_email?: string | null, hosted_invoice_url?: string | null, id: string, invoice_pdf?: string | null, number?: string | null, object: string, paid: boolean, period_end?: number | null, period_start?: number | null, status: string, subtotal: number, subtotal_excluding_tax: number, total: number, charge?: { __typename?: 'Charge', amount?: number | null, created: number, description?: string | null, failure_code?: string | null, failure_message?: string | null, id: string, object: string, paid: boolean, receipt_number?: string | null, receipt_url?: string | null, status: string, payment_method_details?: { __typename?: 'PaymentMethodDetails', card?: { __typename?: 'Card', last4: string, brand?: string | null } | null } | null } | null, total_discount_amounts?: Array<{ __typename?: 'TotalDiscountAmount', amount: number, discount: string }> | null } | null> | null } };

export type FetchCardDetailsQueryVariables = Exact<{
  fetchCardDetailsInput: Scalars['String'];
}>;


export type FetchCardDetailsQuery = { __typename?: 'Query', fetchCardDetails?: { __typename?: 'Card', address_line1?: string | null, address_line2?: string | null, address_state?: string | null, address_zip?: string | null, address_city?: string | null, address_country?: string | null, name?: string | null, exp_month?: number | null, exp_year?: number | null, last4: string, brand?: string | null } | null };

export type ChangeCardMutationVariables = Exact<{
  changeCardInput: ChangeCardInput;
}>;


export type ChangeCardMutation = { __typename?: 'Mutation', changeCard: { __typename?: 'Card', address_line1?: string | null, address_line2?: string | null, address_state?: string | null, address_zip?: string | null, address_city?: string | null, address_country?: string | null, name?: string | null, exp_month?: number | null, exp_year?: number | null, last4: string, brand?: string | null } };

export type FetchBillingDetailsQueryVariables = Exact<{
  fetchCardDetailsInput: Scalars['String'];
}>;


export type FetchBillingDetailsQuery = { __typename?: 'Query', fetchCardDetails?: { __typename?: 'Card', address_line1?: string | null, address_line2?: string | null, address_state?: string | null, address_zip?: string | null, address_city?: string | null, address_country?: string | null, customer_name?: string | null, name?: string | null, exp_month?: number | null, exp_year?: number | null, last4: string, brand?: string | null } | null };


export const LoginDocument = gql`
    mutation Login($loginUser: LoginUserInput!) {
  login(loginUser: $loginUser) {
    accessToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginUser: // value for 'loginUser'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($registerUserInput: RegisterUserInput!) {
  register(registerUserInput: $registerUserInput) {
    email
    emailVerified
    fullName
    phoneNumber
    status
    roles {
      role
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      registerUserInput: // value for 'registerUserInput'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(forgotPasswordInput: $forgotPasswordInput)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const VerifyResetPasswordTokenAndSetPasswordDocument = gql`
    mutation VerifyResetPasswordTokenAndSetPassword($resetPasswordInput: ResetPasswordInput!) {
  verifyResetPasswordTokenAndSetPassword(resetPasswordInput: $resetPasswordInput)
}
    `;
export type VerifyResetPasswordTokenAndSetPasswordMutationFn = Apollo.MutationFunction<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>;

/**
 * __useVerifyResetPasswordTokenAndSetPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyResetPasswordTokenAndSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResetPasswordTokenAndSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResetPasswordTokenAndSetPasswordMutation, { data, loading, error }] = useVerifyResetPasswordTokenAndSetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useVerifyResetPasswordTokenAndSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>(VerifyResetPasswordTokenAndSetPasswordDocument, options);
      }
export type VerifyResetPasswordTokenAndSetPasswordMutationHookResult = ReturnType<typeof useVerifyResetPasswordTokenAndSetPasswordMutation>;
export type VerifyResetPasswordTokenAndSetPasswordMutationResult = Apollo.MutationResult<VerifyResetPasswordTokenAndSetPasswordMutation>;
export type VerifyResetPasswordTokenAndSetPasswordMutationOptions = Apollo.BaseMutationOptions<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  me {
    id
    createdAt
    updatedAt
    fullName
    status
    email
    emailVerified
    phoneVerified
    phoneNumber
    phoneNumberSid
    isTPinAdded
    fcmToken
    defaultMessage
    message
    enablePhoneRinger
    showLogo
    roles {
      role
      id
      createdAt
      updatedAt
    }
    isSubscribed {
      customerStripeId
      subscriptionCancelled
    }
    userSocialSource {
      id
      socialSource {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const VerifyEmailTokenDocument = gql`
    mutation VerifyEmailToken($token: String!) {
  verifyEmailToken(token: $token) {
    email
    roleType
  }
}
    `;
export type VerifyEmailTokenMutationFn = Apollo.MutationFunction<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;

/**
 * __useVerifyEmailTokenMutation__
 *
 * To run a mutation, you first call `useVerifyEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailTokenMutation, { data, loading, error }] = useVerifyEmailTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>(VerifyEmailTokenDocument, options);
      }
export type VerifyEmailTokenMutationHookResult = ReturnType<typeof useVerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationResult = Apollo.MutationResult<VerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationOptions = Apollo.BaseMutationOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;
export const ConsumeMobileHandoffTokenDocument = gql`
    mutation ConsumeMobileHandoffToken($token: String!) {
  consumeMobileHandoffToken(token: $token) {
    accessToken
  }
}
    `;
export type ConsumeMobileHandoffTokenMutationFn = Apollo.MutationFunction<ConsumeMobileHandoffTokenMutation, ConsumeMobileHandoffTokenMutationVariables>;

/**
 * __useConsumeMobileHandoffTokenMutation__
 *
 * To run a mutation, you first call `useConsumeMobileHandoffTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeMobileHandoffTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeMobileHandoffTokenMutation, { data, loading, error }] = useConsumeMobileHandoffTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConsumeMobileHandoffTokenMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeMobileHandoffTokenMutation, ConsumeMobileHandoffTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeMobileHandoffTokenMutation, ConsumeMobileHandoffTokenMutationVariables>(ConsumeMobileHandoffTokenDocument, options);
      }
export type ConsumeMobileHandoffTokenMutationHookResult = ReturnType<typeof useConsumeMobileHandoffTokenMutation>;
export type ConsumeMobileHandoffTokenMutationResult = Apollo.MutationResult<ConsumeMobileHandoffTokenMutation>;
export type ConsumeMobileHandoffTokenMutationOptions = Apollo.BaseMutationOptions<ConsumeMobileHandoffTokenMutation, ConsumeMobileHandoffTokenMutationVariables>;
export const RetrieveCouponPublicDocument = gql`
    query RetrieveCouponPublic($retrieveCouponInput: String!) {
  retrieveCouponPublic(retrieveCouponInput: $retrieveCouponInput) {
    amountOff
    name
    percentOff
    products
    description
    expirationDate
    isActive
    title
  }
}
    `;

/**
 * __useRetrieveCouponPublicQuery__
 *
 * To run a query within a React component, call `useRetrieveCouponPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveCouponPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveCouponPublicQuery({
 *   variables: {
 *      retrieveCouponInput: // value for 'retrieveCouponInput'
 *   },
 * });
 */
export function useRetrieveCouponPublicQuery(baseOptions: Apollo.QueryHookOptions<RetrieveCouponPublicQuery, RetrieveCouponPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveCouponPublicQuery, RetrieveCouponPublicQueryVariables>(RetrieveCouponPublicDocument, options);
      }
export function useRetrieveCouponPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveCouponPublicQuery, RetrieveCouponPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveCouponPublicQuery, RetrieveCouponPublicQueryVariables>(RetrieveCouponPublicDocument, options);
        }
export type RetrieveCouponPublicQueryHookResult = ReturnType<typeof useRetrieveCouponPublicQuery>;
export type RetrieveCouponPublicLazyQueryHookResult = ReturnType<typeof useRetrieveCouponPublicLazyQuery>;
export type RetrieveCouponPublicQueryResult = Apollo.QueryResult<RetrieveCouponPublicQuery, RetrieveCouponPublicQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($createContactInput: CreateContactInput!) {
  createContact(createContactInput: $createContactInput) {
    id
    createdAt
    updatedAt
    phoneNumber
    priority
    nickName
    name
    phoneType
    email
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      createContactInput: // value for 'createContactInput'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const FetchAllContactsDocument = gql`
    query FetchAllContacts {
  fetchAllContacts {
    id
    createdAt
    updatedAt
    phoneNumber
    priority
    nickName
    name
    phoneType
    email
  }
}
    `;

/**
 * __useFetchAllContactsQuery__
 *
 * To run a query within a React component, call `useFetchAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllContactsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllContactsQuery, FetchAllContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllContactsQuery, FetchAllContactsQueryVariables>(FetchAllContactsDocument, options);
      }
export function useFetchAllContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllContactsQuery, FetchAllContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllContactsQuery, FetchAllContactsQueryVariables>(FetchAllContactsDocument, options);
        }
export type FetchAllContactsQueryHookResult = ReturnType<typeof useFetchAllContactsQuery>;
export type FetchAllContactsLazyQueryHookResult = ReturnType<typeof useFetchAllContactsLazyQuery>;
export type FetchAllContactsQueryResult = Apollo.QueryResult<FetchAllContactsQuery, FetchAllContactsQueryVariables>;
export const FetchAllOptedOutContactsDocument = gql`
    query FetchAllOptedOutContacts {
  fetchAllOptedOutContacts {
    id
    createdAt
    updatedAt
    phoneNumber
    priority
    nickName
    name
    phoneType
    email
  }
}
    `;

/**
 * __useFetchAllOptedOutContactsQuery__
 *
 * To run a query within a React component, call `useFetchAllOptedOutContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllOptedOutContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllOptedOutContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllOptedOutContactsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllOptedOutContactsQuery, FetchAllOptedOutContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllOptedOutContactsQuery, FetchAllOptedOutContactsQueryVariables>(FetchAllOptedOutContactsDocument, options);
      }
export function useFetchAllOptedOutContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllOptedOutContactsQuery, FetchAllOptedOutContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllOptedOutContactsQuery, FetchAllOptedOutContactsQueryVariables>(FetchAllOptedOutContactsDocument, options);
        }
export type FetchAllOptedOutContactsQueryHookResult = ReturnType<typeof useFetchAllOptedOutContactsQuery>;
export type FetchAllOptedOutContactsLazyQueryHookResult = ReturnType<typeof useFetchAllOptedOutContactsLazyQuery>;
export type FetchAllOptedOutContactsQueryResult = Apollo.QueryResult<FetchAllOptedOutContactsQuery, FetchAllOptedOutContactsQueryVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($updateContactInput: UpdateContactInput!) {
  updateContact(updateContactInput: $updateContactInput) {
    id
    createdAt
    updatedAt
    phoneNumber
    nickName
    name
    phoneType
    email
    priority
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      updateContactInput: // value for 'updateContactInput'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const SwapContactPriorityDocument = gql`
    mutation SwapContactPriority($swapContactPriorityInput: SwapPriorityInput!) {
  swapContactPriority(swapContactPriorityInput: $swapContactPriorityInput) {
    updatedAt
    priority
    phoneNumber
    phoneType
    nickName
    name
    id
    createdAt
    email
  }
}
    `;
export type SwapContactPriorityMutationFn = Apollo.MutationFunction<SwapContactPriorityMutation, SwapContactPriorityMutationVariables>;

/**
 * __useSwapContactPriorityMutation__
 *
 * To run a mutation, you first call `useSwapContactPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapContactPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapContactPriorityMutation, { data, loading, error }] = useSwapContactPriorityMutation({
 *   variables: {
 *      swapContactPriorityInput: // value for 'swapContactPriorityInput'
 *   },
 * });
 */
export function useSwapContactPriorityMutation(baseOptions?: Apollo.MutationHookOptions<SwapContactPriorityMutation, SwapContactPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapContactPriorityMutation, SwapContactPriorityMutationVariables>(SwapContactPriorityDocument, options);
      }
export type SwapContactPriorityMutationHookResult = ReturnType<typeof useSwapContactPriorityMutation>;
export type SwapContactPriorityMutationResult = Apollo.MutationResult<SwapContactPriorityMutation>;
export type SwapContactPriorityMutationOptions = Apollo.BaseMutationOptions<SwapContactPriorityMutation, SwapContactPriorityMutationVariables>;
export const GetSubscriptionDetailDocument = gql`
    query GetSubscriptionDetail($customerStripeId: String!) {
  getSubscriptionDetail(customerStripeId: $customerStripeId) {
    data {
      application
      application_fee_percent
      automatic_tax {
        enabled
      }
      billing_cycle_anchor
      billing_thresholds {
        amount_gte
        reset_billing_cycle_anchor
      }
      cancel_at
      cancel_at_period_end
      canceled_at
      cancellation_details {
        comment
        feedback
        reason
      }
      created
      default_payment_method
      default_source
      default_tax_rates {
        active
        country
        created
        description
        display_name
        effective_percentage
        id
        inclusive
        jurisdiction
        livemode
        object
        percentage
        state
      }
      description
      ended_at
      id
      items {
        data {
          plan {
            nickname
            amount
            product
            productDetails {
              id
              name
              marketing_features {
                name
              }
            }
            metadata
            interval
            id
            created
          }
          created
          id
          object
          plan {
            active
            aggregate_usage
            amount
            amount_decimal
            billing_scheme
            created
            currency
            id
            interval
            metadata
            nickname
            object
            product
            productDetails {
              id
              name
              marketing_features {
                name
              }
            }
            tiers_mode
            transform_usage {
              divide_by
              round
            }
            trial_period_days
            usage_type
          }
          quantity
          subscription
        }
      }
      latest_invoice
      livemode
      next_pending_invoice_item_invoice
      object
      on_behalf_of
      pause_collection {
        behavior
        resumes_at
      }
      pending_invoice_item_interval {
        interval
      }
      schedule
      start_date
      status
      transfer_data {
        amount_percent
        destination
      }
      trial_end
      trial_settings {
        end_behavior {
          missing_payment_method
        }
      }
      trial_start
      current_period_end
    }
  }
}
    `;

/**
 * __useGetSubscriptionDetailQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDetailQuery({
 *   variables: {
 *      customerStripeId: // value for 'customerStripeId'
 *   },
 * });
 */
export function useGetSubscriptionDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>(GetSubscriptionDetailDocument, options);
      }
export function useGetSubscriptionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>(GetSubscriptionDetailDocument, options);
        }
export type GetSubscriptionDetailQueryHookResult = ReturnType<typeof useGetSubscriptionDetailQuery>;
export type GetSubscriptionDetailLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDetailLazyQuery>;
export type GetSubscriptionDetailQueryResult = Apollo.QueryResult<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($deleteContactInput: DeleteContactInput!) {
  deleteContact(deleteContactInput: $deleteContactInput) {
    id
    priority
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      deleteContactInput: // value for 'deleteContactInput'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const OptOutContactDocument = gql`
    mutation OptOutContact($optOutContactInput: OptOutContactInput!) {
  optOutContact(optOutContactInput: $optOutContactInput) {
    message
  }
}
    `;
export type OptOutContactMutationFn = Apollo.MutationFunction<OptOutContactMutation, OptOutContactMutationVariables>;

/**
 * __useOptOutContactMutation__
 *
 * To run a mutation, you first call `useOptOutContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptOutContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optOutContactMutation, { data, loading, error }] = useOptOutContactMutation({
 *   variables: {
 *      optOutContactInput: // value for 'optOutContactInput'
 *   },
 * });
 */
export function useOptOutContactMutation(baseOptions?: Apollo.MutationHookOptions<OptOutContactMutation, OptOutContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptOutContactMutation, OptOutContactMutationVariables>(OptOutContactDocument, options);
      }
export type OptOutContactMutationHookResult = ReturnType<typeof useOptOutContactMutation>;
export type OptOutContactMutationResult = Apollo.MutationResult<OptOutContactMutation>;
export type OptOutContactMutationOptions = Apollo.BaseMutationOptions<OptOutContactMutation, OptOutContactMutationVariables>;
export const ValidateTokenContactDocument = gql`
    query ValidateTokenContact($optOutContactInput: OptOutContactInput!) {
  validateTokenContact(optOutContactInput: $optOutContactInput) {
    phoneNo
    name
  }
}
    `;

/**
 * __useValidateTokenContactQuery__
 *
 * To run a query within a React component, call `useValidateTokenContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTokenContactQuery({
 *   variables: {
 *      optOutContactInput: // value for 'optOutContactInput'
 *   },
 * });
 */
export function useValidateTokenContactQuery(baseOptions: Apollo.QueryHookOptions<ValidateTokenContactQuery, ValidateTokenContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateTokenContactQuery, ValidateTokenContactQueryVariables>(ValidateTokenContactDocument, options);
      }
export function useValidateTokenContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateTokenContactQuery, ValidateTokenContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateTokenContactQuery, ValidateTokenContactQueryVariables>(ValidateTokenContactDocument, options);
        }
export type ValidateTokenContactQueryHookResult = ReturnType<typeof useValidateTokenContactQuery>;
export type ValidateTokenContactLazyQueryHookResult = ReturnType<typeof useValidateTokenContactLazyQuery>;
export type ValidateTokenContactQueryResult = Apollo.QueryResult<ValidateTokenContactQuery, ValidateTokenContactQueryVariables>;
export const RingMyPhoneDocument = gql`
    query RingMyPhone {
  ringMyPhone {
    id
    ringMyPhoneStatus
    longitude
    latitude
    notificationType
    status
  }
}
    `;

/**
 * __useRingMyPhoneQuery__
 *
 * To run a query within a React component, call `useRingMyPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRingMyPhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRingMyPhoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useRingMyPhoneQuery(baseOptions?: Apollo.QueryHookOptions<RingMyPhoneQuery, RingMyPhoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RingMyPhoneQuery, RingMyPhoneQueryVariables>(RingMyPhoneDocument, options);
      }
export function useRingMyPhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RingMyPhoneQuery, RingMyPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RingMyPhoneQuery, RingMyPhoneQueryVariables>(RingMyPhoneDocument, options);
        }
export type RingMyPhoneQueryHookResult = ReturnType<typeof useRingMyPhoneQuery>;
export type RingMyPhoneLazyQueryHookResult = ReturnType<typeof useRingMyPhoneLazyQuery>;
export type RingMyPhoneQueryResult = Apollo.QueryResult<RingMyPhoneQuery, RingMyPhoneQueryVariables>;
export const RecentRingMyPhoneLogsDocument = gql`
    query RecentRingMyPhoneLogs($input: PaginationInput!) {
  recentRingMyPhoneLogs(input: $input) {
    ringMyPhoneLogs {
      id
      status
      notificationType
      ringMyPhoneStatus
      createdAt
      longitude
      latitude
      price
      phone
    }
    pagination {
      hasMore
      totalCount
      totalPages
      page
      limit
    }
  }
}
    `;

/**
 * __useRecentRingMyPhoneLogsQuery__
 *
 * To run a query within a React component, call `useRecentRingMyPhoneLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentRingMyPhoneLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentRingMyPhoneLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecentRingMyPhoneLogsQuery(baseOptions: Apollo.QueryHookOptions<RecentRingMyPhoneLogsQuery, RecentRingMyPhoneLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentRingMyPhoneLogsQuery, RecentRingMyPhoneLogsQueryVariables>(RecentRingMyPhoneLogsDocument, options);
      }
export function useRecentRingMyPhoneLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentRingMyPhoneLogsQuery, RecentRingMyPhoneLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentRingMyPhoneLogsQuery, RecentRingMyPhoneLogsQueryVariables>(RecentRingMyPhoneLogsDocument, options);
        }
export type RecentRingMyPhoneLogsQueryHookResult = ReturnType<typeof useRecentRingMyPhoneLogsQuery>;
export type RecentRingMyPhoneLogsLazyQueryHookResult = ReturnType<typeof useRecentRingMyPhoneLogsLazyQuery>;
export type RecentRingMyPhoneLogsQueryResult = Apollo.QueryResult<RecentRingMyPhoneLogsQuery, RecentRingMyPhoneLogsQueryVariables>;
export const FetchVipContactDocument = gql`
    query FetchVipContact {
  fetchVipContact {
    name
    phoneNumber
  }
}
    `;

/**
 * __useFetchVipContactQuery__
 *
 * To run a query within a React component, call `useFetchVipContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVipContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVipContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchVipContactQuery(baseOptions?: Apollo.QueryHookOptions<FetchVipContactQuery, FetchVipContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchVipContactQuery, FetchVipContactQueryVariables>(FetchVipContactDocument, options);
      }
export function useFetchVipContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchVipContactQuery, FetchVipContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchVipContactQuery, FetchVipContactQueryVariables>(FetchVipContactDocument, options);
        }
export type FetchVipContactQueryHookResult = ReturnType<typeof useFetchVipContactQuery>;
export type FetchVipContactLazyQueryHookResult = ReturnType<typeof useFetchVipContactLazyQuery>;
export type FetchVipContactQueryResult = Apollo.QueryResult<FetchVipContactQuery, FetchVipContactQueryVariables>;
export const UserRingMyPhoneSettingsDocument = gql`
    mutation UserRingMyPhoneSettings($UserRingMyPhoneInput: UserRingMyPhoneInput!) {
  userRingMyPhoneSettings(userRingMyPhoneInput: $UserRingMyPhoneInput)
}
    `;
export type UserRingMyPhoneSettingsMutationFn = Apollo.MutationFunction<UserRingMyPhoneSettingsMutation, UserRingMyPhoneSettingsMutationVariables>;

/**
 * __useUserRingMyPhoneSettingsMutation__
 *
 * To run a mutation, you first call `useUserRingMyPhoneSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRingMyPhoneSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRingMyPhoneSettingsMutation, { data, loading, error }] = useUserRingMyPhoneSettingsMutation({
 *   variables: {
 *      UserRingMyPhoneInput: // value for 'UserRingMyPhoneInput'
 *   },
 * });
 */
export function useUserRingMyPhoneSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UserRingMyPhoneSettingsMutation, UserRingMyPhoneSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRingMyPhoneSettingsMutation, UserRingMyPhoneSettingsMutationVariables>(UserRingMyPhoneSettingsDocument, options);
      }
export type UserRingMyPhoneSettingsMutationHookResult = ReturnType<typeof useUserRingMyPhoneSettingsMutation>;
export type UserRingMyPhoneSettingsMutationResult = Apollo.MutationResult<UserRingMyPhoneSettingsMutation>;
export type UserRingMyPhoneSettingsMutationOptions = Apollo.BaseMutationOptions<UserRingMyPhoneSettingsMutation, UserRingMyPhoneSettingsMutationVariables>;
export const FetchRingMyPhoneLogDocument = gql`
    query FetchRingMyPhoneLog($FetchRingMyPhoneLogInput: FetchRingMyPhoneLogInput!) {
  fetchRingMyPhoneLog(fetchRingMyPhoneLogInput: $FetchRingMyPhoneLogInput) {
    id
    status
    notificationType
    ringMyPhoneStatus
    latitude
    longitude
    createdAt
  }
}
    `;

/**
 * __useFetchRingMyPhoneLogQuery__
 *
 * To run a query within a React component, call `useFetchRingMyPhoneLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRingMyPhoneLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRingMyPhoneLogQuery({
 *   variables: {
 *      FetchRingMyPhoneLogInput: // value for 'FetchRingMyPhoneLogInput'
 *   },
 * });
 */
export function useFetchRingMyPhoneLogQuery(baseOptions: Apollo.QueryHookOptions<FetchRingMyPhoneLogQuery, FetchRingMyPhoneLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRingMyPhoneLogQuery, FetchRingMyPhoneLogQueryVariables>(FetchRingMyPhoneLogDocument, options);
      }
export function useFetchRingMyPhoneLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRingMyPhoneLogQuery, FetchRingMyPhoneLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRingMyPhoneLogQuery, FetchRingMyPhoneLogQueryVariables>(FetchRingMyPhoneLogDocument, options);
        }
export type FetchRingMyPhoneLogQueryHookResult = ReturnType<typeof useFetchRingMyPhoneLogQuery>;
export type FetchRingMyPhoneLogLazyQueryHookResult = ReturnType<typeof useFetchRingMyPhoneLogLazyQuery>;
export type FetchRingMyPhoneLogQueryResult = Apollo.QueryResult<FetchRingMyPhoneLogQuery, FetchRingMyPhoneLogQueryVariables>;
export const FetchRecentCallLogDocument = gql`
    query FetchRecentCallLog($fetchRecentCallLogInput: FetchRecentCallLogInput!) {
  fetchRecentCallLog(fetchRecentCallLogInput: $fetchRecentCallLogInput) {
    id
    status
    notificationType
    ringMyPhoneStatus
  }
}
    `;

/**
 * __useFetchRecentCallLogQuery__
 *
 * To run a query within a React component, call `useFetchRecentCallLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentCallLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentCallLogQuery({
 *   variables: {
 *      fetchRecentCallLogInput: // value for 'fetchRecentCallLogInput'
 *   },
 * });
 */
export function useFetchRecentCallLogQuery(baseOptions: Apollo.QueryHookOptions<FetchRecentCallLogQuery, FetchRecentCallLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRecentCallLogQuery, FetchRecentCallLogQueryVariables>(FetchRecentCallLogDocument, options);
      }
export function useFetchRecentCallLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRecentCallLogQuery, FetchRecentCallLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRecentCallLogQuery, FetchRecentCallLogQueryVariables>(FetchRecentCallLogDocument, options);
        }
export type FetchRecentCallLogQueryHookResult = ReturnType<typeof useFetchRecentCallLogQuery>;
export type FetchRecentCallLogLazyQueryHookResult = ReturnType<typeof useFetchRecentCallLogLazyQuery>;
export type FetchRecentCallLogQueryResult = Apollo.QueryResult<FetchRecentCallLogQuery, FetchRecentCallLogQueryVariables>;
export const FetchDefaultMessageDocument = gql`
    query FetchDefaultMessage {
  fetchDefaultMessage
}
    `;

/**
 * __useFetchDefaultMessageQuery__
 *
 * To run a query within a React component, call `useFetchDefaultMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDefaultMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDefaultMessageQuery(baseOptions?: Apollo.QueryHookOptions<FetchDefaultMessageQuery, FetchDefaultMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDefaultMessageQuery, FetchDefaultMessageQueryVariables>(FetchDefaultMessageDocument, options);
      }
export function useFetchDefaultMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDefaultMessageQuery, FetchDefaultMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDefaultMessageQuery, FetchDefaultMessageQueryVariables>(FetchDefaultMessageDocument, options);
        }
export type FetchDefaultMessageQueryHookResult = ReturnType<typeof useFetchDefaultMessageQuery>;
export type FetchDefaultMessageLazyQueryHookResult = ReturnType<typeof useFetchDefaultMessageLazyQuery>;
export type FetchDefaultMessageQueryResult = Apollo.QueryResult<FetchDefaultMessageQuery, FetchDefaultMessageQueryVariables>;
export const ValidateTokenOptInDocument = gql`
    query ValidateTokenOptIn($optOutContactInput: OptOutContactInput!) {
  validateTokenOptIn(optOutContactInput: $optOutContactInput) {
    name
    phoneNo
  }
}
    `;

/**
 * __useValidateTokenOptInQuery__
 *
 * To run a query within a React component, call `useValidateTokenOptInQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenOptInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTokenOptInQuery({
 *   variables: {
 *      optOutContactInput: // value for 'optOutContactInput'
 *   },
 * });
 */
export function useValidateTokenOptInQuery(baseOptions: Apollo.QueryHookOptions<ValidateTokenOptInQuery, ValidateTokenOptInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateTokenOptInQuery, ValidateTokenOptInQueryVariables>(ValidateTokenOptInDocument, options);
      }
export function useValidateTokenOptInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateTokenOptInQuery, ValidateTokenOptInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateTokenOptInQuery, ValidateTokenOptInQueryVariables>(ValidateTokenOptInDocument, options);
        }
export type ValidateTokenOptInQueryHookResult = ReturnType<typeof useValidateTokenOptInQuery>;
export type ValidateTokenOptInLazyQueryHookResult = ReturnType<typeof useValidateTokenOptInLazyQuery>;
export type ValidateTokenOptInQueryResult = Apollo.QueryResult<ValidateTokenOptInQuery, ValidateTokenOptInQueryVariables>;
export const ContactOptDocument = gql`
    mutation ContactOpt($input: ContactOptInInput!) {
  contactOpt(input: $input)
}
    `;
export type ContactOptMutationFn = Apollo.MutationFunction<ContactOptMutation, ContactOptMutationVariables>;

/**
 * __useContactOptMutation__
 *
 * To run a mutation, you first call `useContactOptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactOptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactOptMutation, { data, loading, error }] = useContactOptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactOptMutation(baseOptions?: Apollo.MutationHookOptions<ContactOptMutation, ContactOptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactOptMutation, ContactOptMutationVariables>(ContactOptDocument, options);
      }
export type ContactOptMutationHookResult = ReturnType<typeof useContactOptMutation>;
export type ContactOptMutationResult = Apollo.MutationResult<ContactOptMutation>;
export type ContactOptMutationOptions = Apollo.BaseMutationOptions<ContactOptMutation, ContactOptMutationVariables>;
export const SendOtpDocument = gql`
    mutation SendOtp($sendOtpInput: SendOtpInput!) {
  sendOtp(sendOtpInput: $sendOtpInput) {
    code
    sendOtp
  }
}
    `;
export type SendOtpMutationFn = Apollo.MutationFunction<SendOtpMutation, SendOtpMutationVariables>;

/**
 * __useSendOtpMutation__
 *
 * To run a mutation, you first call `useSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpMutation, { data, loading, error }] = useSendOtpMutation({
 *   variables: {
 *      sendOtpInput: // value for 'sendOtpInput'
 *   },
 * });
 */
export function useSendOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendOtpMutation, SendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOtpMutation, SendOtpMutationVariables>(SendOtpDocument, options);
      }
export type SendOtpMutationHookResult = ReturnType<typeof useSendOtpMutation>;
export type SendOtpMutationResult = Apollo.MutationResult<SendOtpMutation>;
export type SendOtpMutationOptions = Apollo.BaseMutationOptions<SendOtpMutation, SendOtpMutationVariables>;
export const SendOtpV2Document = gql`
    mutation SendOtpV2($sendOtpInputV2: SendOtpInput!) {
  sendOtpV2(sendOtpInputV2: $sendOtpInputV2) {
    code
    sendOtp
  }
}
    `;
export type SendOtpV2MutationFn = Apollo.MutationFunction<SendOtpV2Mutation, SendOtpV2MutationVariables>;

/**
 * __useSendOtpV2Mutation__
 *
 * To run a mutation, you first call `useSendOtpV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpV2Mutation, { data, loading, error }] = useSendOtpV2Mutation({
 *   variables: {
 *      sendOtpInputV2: // value for 'sendOtpInputV2'
 *   },
 * });
 */
export function useSendOtpV2Mutation(baseOptions?: Apollo.MutationHookOptions<SendOtpV2Mutation, SendOtpV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOtpV2Mutation, SendOtpV2MutationVariables>(SendOtpV2Document, options);
      }
export type SendOtpV2MutationHookResult = ReturnType<typeof useSendOtpV2Mutation>;
export type SendOtpV2MutationResult = Apollo.MutationResult<SendOtpV2Mutation>;
export type SendOtpV2MutationOptions = Apollo.BaseMutationOptions<SendOtpV2Mutation, SendOtpV2MutationVariables>;
export const FetchPhoneVerifiedDocument = gql`
    query FetchPhoneVerified {
  me {
    phoneVerified
    phoneNumber
    phoneNumberSid
  }
}
    `;

/**
 * __useFetchPhoneVerifiedQuery__
 *
 * To run a query within a React component, call `useFetchPhoneVerifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPhoneVerifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPhoneVerifiedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPhoneVerifiedQuery(baseOptions?: Apollo.QueryHookOptions<FetchPhoneVerifiedQuery, FetchPhoneVerifiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPhoneVerifiedQuery, FetchPhoneVerifiedQueryVariables>(FetchPhoneVerifiedDocument, options);
      }
export function useFetchPhoneVerifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPhoneVerifiedQuery, FetchPhoneVerifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPhoneVerifiedQuery, FetchPhoneVerifiedQueryVariables>(FetchPhoneVerifiedDocument, options);
        }
export type FetchPhoneVerifiedQueryHookResult = ReturnType<typeof useFetchPhoneVerifiedQuery>;
export type FetchPhoneVerifiedLazyQueryHookResult = ReturnType<typeof useFetchPhoneVerifiedLazyQuery>;
export type FetchPhoneVerifiedQueryResult = Apollo.QueryResult<FetchPhoneVerifiedQuery, FetchPhoneVerifiedQueryVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOtp($verifyOtpInput: OtpVerifyInput!) {
  verifyOtp(verifyOtpInput: $verifyOtpInput) {
    phoneNumber
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      verifyOtpInput: // value for 'verifyOtpInput'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const AddSecurityPinDocument = gql`
    mutation AddSecurityPin($addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin!) {
  addSecurityPin(addOrUpdateSecurityPinInput: $addOrUpdateSecurityPinInput)
}
    `;
export type AddSecurityPinMutationFn = Apollo.MutationFunction<AddSecurityPinMutation, AddSecurityPinMutationVariables>;

/**
 * __useAddSecurityPinMutation__
 *
 * To run a mutation, you first call `useAddSecurityPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSecurityPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSecurityPinMutation, { data, loading, error }] = useAddSecurityPinMutation({
 *   variables: {
 *      addOrUpdateSecurityPinInput: // value for 'addOrUpdateSecurityPinInput'
 *   },
 * });
 */
export function useAddSecurityPinMutation(baseOptions?: Apollo.MutationHookOptions<AddSecurityPinMutation, AddSecurityPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSecurityPinMutation, AddSecurityPinMutationVariables>(AddSecurityPinDocument, options);
      }
export type AddSecurityPinMutationHookResult = ReturnType<typeof useAddSecurityPinMutation>;
export type AddSecurityPinMutationResult = Apollo.MutationResult<AddSecurityPinMutation>;
export type AddSecurityPinMutationOptions = Apollo.BaseMutationOptions<AddSecurityPinMutation, AddSecurityPinMutationVariables>;
export const FetchPlanDocument = gql`
    query FetchPlan {
  fetchPlan {
    data {
      active
      aggregate_usage
      amount
      amount_decimal
      billing_scheme
      created
      currency
      id
      interval
      metadata
      nickname
      object
      product
      productDetails {
        id
        name
        marketing_features {
          name
        }
      }
      tiers {
        flat_amount
        flat_amount_decimal
        unit_amount
        unit_amount_decimal
        up_to
      }
      tiers_mode
      transform_usage {
        divide_by
        round
      }
      trial_period_days
      usage_type
    }
    trialEnded
  }
}
    `;

/**
 * __useFetchPlanQuery__
 *
 * To run a query within a React component, call `useFetchPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPlanQuery(baseOptions?: Apollo.QueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
      }
export function useFetchPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
        }
export type FetchPlanQueryHookResult = ReturnType<typeof useFetchPlanQuery>;
export type FetchPlanLazyQueryHookResult = ReturnType<typeof useFetchPlanLazyQuery>;
export type FetchPlanQueryResult = Apollo.QueryResult<FetchPlanQuery, FetchPlanQueryVariables>;
export const RetrieveCouponDocument = gql`
    query RetrieveCoupon($retrieveCouponInput: String!) {
  retrieveCoupon(retrieveCouponInput: $retrieveCouponInput) {
    amountOff
    name
    percentOff
    products
  }
}
    `;

/**
 * __useRetrieveCouponQuery__
 *
 * To run a query within a React component, call `useRetrieveCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveCouponQuery({
 *   variables: {
 *      retrieveCouponInput: // value for 'retrieveCouponInput'
 *   },
 * });
 */
export function useRetrieveCouponQuery(baseOptions: Apollo.QueryHookOptions<RetrieveCouponQuery, RetrieveCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveCouponQuery, RetrieveCouponQueryVariables>(RetrieveCouponDocument, options);
      }
export function useRetrieveCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveCouponQuery, RetrieveCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveCouponQuery, RetrieveCouponQueryVariables>(RetrieveCouponDocument, options);
        }
export type RetrieveCouponQueryHookResult = ReturnType<typeof useRetrieveCouponQuery>;
export type RetrieveCouponLazyQueryHookResult = ReturnType<typeof useRetrieveCouponLazyQuery>;
export type RetrieveCouponQueryResult = Apollo.QueryResult<RetrieveCouponQuery, RetrieveCouponQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($createSubscriptionInput: CreateSubscriptionInput!) {
  createSubscription(createSubscriptionInput: $createSubscriptionInput) {
    customerStripeId
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionPlanDocument = gql`
    mutation UpdateSubscriptionPlan($updateSubscriptionPlanInput: UpdateSubscriptionPlan!) {
  updateSubscriptionPlan(
    updateSubscriptionPlanInput: $updateSubscriptionPlanInput
  ) {
    application
    application_fee_percent
    automatic_tax {
      enabled
    }
    billing_cycle_anchor
    billing_thresholds {
      amount_gte
      reset_billing_cycle_anchor
    }
    cancel_at
    cancel_at_period_end
    canceled_at
    cancellation_details {
      comment
      feedback
      reason
    }
    created
    default_payment_method
    default_source
    default_tax_rates {
      active
      country
      created
      description
      display_name
      effective_percentage
      id
      inclusive
      jurisdiction
      livemode
      object
      percentage
      state
    }
    description
    ended_at
    id
    items {
      data {
        billing_thresholds {
          amount_gte
          reset_billing_cycle_anchor
        }
        created
        id
        object
        plan {
          active
          aggregate_usage
          amount
          amount_decimal
          billing_scheme
          created
          currency
          id
          interval
          metadata
          nickname
          object
          product
          tiers_mode
          transform_usage {
            divide_by
            round
          }
          trial_period_days
          usage_type
        }
        quantity
        subscription
      }
    }
    latest_invoice
    livemode
    next_pending_invoice_item_invoice
    object
    on_behalf_of
    pause_collection {
      behavior
      resumes_at
    }
    pending_invoice_item_interval {
      interval
    }
    schedule
    start_date
    status
    transfer_data {
      amount_percent
      destination
    }
    trial_end
    trial_settings {
      end_behavior {
        missing_payment_method
      }
    }
    trial_start
  }
}
    `;
export type UpdateSubscriptionPlanMutationFn = Apollo.MutationFunction<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>;

/**
 * __useUpdateSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionPlanMutation, { data, loading, error }] = useUpdateSubscriptionPlanMutation({
 *   variables: {
 *      updateSubscriptionPlanInput: // value for 'updateSubscriptionPlanInput'
 *   },
 * });
 */
export function useUpdateSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>(UpdateSubscriptionPlanDocument, options);
      }
export type UpdateSubscriptionPlanMutationHookResult = ReturnType<typeof useUpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationResult = Apollo.MutationResult<UpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>;
export const CreateClientSecretDocument = gql`
    mutation CreateClientSecret($createSubscriptionInput: CreateSubscriptionInput!) {
  createClientSecret(createSubscriptionInput: $createSubscriptionInput) {
    clientSecret
  }
}
    `;
export type CreateClientSecretMutationFn = Apollo.MutationFunction<CreateClientSecretMutation, CreateClientSecretMutationVariables>;

/**
 * __useCreateClientSecretMutation__
 *
 * To run a mutation, you first call `useCreateClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientSecretMutation, { data, loading, error }] = useCreateClientSecretMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *   },
 * });
 */
export function useCreateClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientSecretMutation, CreateClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientSecretMutation, CreateClientSecretMutationVariables>(CreateClientSecretDocument, options);
      }
export type CreateClientSecretMutationHookResult = ReturnType<typeof useCreateClientSecretMutation>;
export type CreateClientSecretMutationResult = Apollo.MutationResult<CreateClientSecretMutation>;
export type CreateClientSecretMutationOptions = Apollo.BaseMutationOptions<CreateClientSecretMutation, CreateClientSecretMutationVariables>;
export const ConfirmWalletPaymentDocument = gql`
    mutation ConfirmWalletPayment($confirmWalletPaymentInput: ConfirmWalletPaymentInput!) {
  confirmWalletPayment(confirmWalletPaymentInput: $confirmWalletPaymentInput) {
    customerStripeId
  }
}
    `;
export type ConfirmWalletPaymentMutationFn = Apollo.MutationFunction<ConfirmWalletPaymentMutation, ConfirmWalletPaymentMutationVariables>;

/**
 * __useConfirmWalletPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmWalletPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmWalletPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmWalletPaymentMutation, { data, loading, error }] = useConfirmWalletPaymentMutation({
 *   variables: {
 *      confirmWalletPaymentInput: // value for 'confirmWalletPaymentInput'
 *   },
 * });
 */
export function useConfirmWalletPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmWalletPaymentMutation, ConfirmWalletPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmWalletPaymentMutation, ConfirmWalletPaymentMutationVariables>(ConfirmWalletPaymentDocument, options);
      }
export type ConfirmWalletPaymentMutationHookResult = ReturnType<typeof useConfirmWalletPaymentMutation>;
export type ConfirmWalletPaymentMutationResult = Apollo.MutationResult<ConfirmWalletPaymentMutation>;
export type ConfirmWalletPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmWalletPaymentMutation, ConfirmWalletPaymentMutationVariables>;
export const UpdateNameDocument = gql`
    mutation UpdateName($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    fullName
  }
}
    `;
export type UpdateNameMutationFn = Apollo.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>;

/**
 * __useUpdateNameMutation__
 *
 * To run a mutation, you first call `useUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameMutation, { data, loading, error }] = useUpdateNameMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNameMutation, UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNameMutation, UpdateNameMutationVariables>(UpdateNameDocument, options);
      }
export type UpdateNameMutationHookResult = ReturnType<typeof useUpdateNameMutation>;
export type UpdateNameMutationResult = Apollo.MutationResult<UpdateNameMutation>;
export type UpdateNameMutationOptions = Apollo.BaseMutationOptions<UpdateNameMutation, UpdateNameMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    email
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($updateUserPasswordInput: UpdateUserPasswordInput!) {
  updateUserPassword(updateUserPasswordInput: $updateUserPasswordInput) {
    id
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      updateUserPasswordInput: // value for 'updateUserPasswordInput'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdatePhoneNumberDocument = gql`
    mutation UpdatePhoneNumber($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    phoneNumber
  }
}
    `;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const DeactivateUserAccountDocument = gql`
    mutation DeactivateUserAccount {
  deactivateUserAccount {
    status
  }
}
    `;
export type DeactivateUserAccountMutationFn = Apollo.MutationFunction<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;

/**
 * __useDeactivateUserAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserAccountMutation, { data, loading, error }] = useDeactivateUserAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>(DeactivateUserAccountDocument, options);
      }
export type DeactivateUserAccountMutationHookResult = ReturnType<typeof useDeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationResult = Apollo.MutationResult<DeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationOptions = Apollo.BaseMutationOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;
export const UpdateCardDetailDocument = gql`
    mutation UpdateCardDetail($updateCardDetails: UpdateCardDetailInput!) {
  updateCardDetail(updateCardDetails: $updateCardDetails) {
    address_city
    address_country
    address_line1
    address_line2
    address_state
    address_zip
    name
  }
}
    `;
export type UpdateCardDetailMutationFn = Apollo.MutationFunction<UpdateCardDetailMutation, UpdateCardDetailMutationVariables>;

/**
 * __useUpdateCardDetailMutation__
 *
 * To run a mutation, you first call `useUpdateCardDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardDetailMutation, { data, loading, error }] = useUpdateCardDetailMutation({
 *   variables: {
 *      updateCardDetails: // value for 'updateCardDetails'
 *   },
 * });
 */
export function useUpdateCardDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardDetailMutation, UpdateCardDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardDetailMutation, UpdateCardDetailMutationVariables>(UpdateCardDetailDocument, options);
      }
export type UpdateCardDetailMutationHookResult = ReturnType<typeof useUpdateCardDetailMutation>;
export type UpdateCardDetailMutationResult = Apollo.MutationResult<UpdateCardDetailMutation>;
export type UpdateCardDetailMutationOptions = Apollo.BaseMutationOptions<UpdateCardDetailMutation, UpdateCardDetailMutationVariables>;
export const FetchSocialSourcesDocument = gql`
    query FetchSocialSources($input: PaginationInput!) {
  fetchSocialSources(input: $input) {
    pagination {
      page
      totalCount
      limit
      totalPages
    }
    socialSources {
      id
      name
      totalUsersReached
    }
  }
}
    `;

/**
 * __useFetchSocialSourcesQuery__
 *
 * To run a query within a React component, call `useFetchSocialSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSocialSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSocialSourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchSocialSourcesQuery(baseOptions: Apollo.QueryHookOptions<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>(FetchSocialSourcesDocument, options);
      }
export function useFetchSocialSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>(FetchSocialSourcesDocument, options);
        }
export type FetchSocialSourcesQueryHookResult = ReturnType<typeof useFetchSocialSourcesQuery>;
export type FetchSocialSourcesLazyQueryHookResult = ReturnType<typeof useFetchSocialSourcesLazyQuery>;
export type FetchSocialSourcesQueryResult = Apollo.QueryResult<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>;
export const UpdateUserSocialSourceDocument = gql`
    mutation UpdateUserSocialSource($input: UpdateUserSocialSourceInput!) {
  updateUserSocialSource(input: $input) {
    id
    socialSource {
      id
      name
    }
  }
}
    `;
export type UpdateUserSocialSourceMutationFn = Apollo.MutationFunction<UpdateUserSocialSourceMutation, UpdateUserSocialSourceMutationVariables>;

/**
 * __useUpdateUserSocialSourceMutation__
 *
 * To run a mutation, you first call `useUpdateUserSocialSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSocialSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSocialSourceMutation, { data, loading, error }] = useUpdateUserSocialSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSocialSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSocialSourceMutation, UpdateUserSocialSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSocialSourceMutation, UpdateUserSocialSourceMutationVariables>(UpdateUserSocialSourceDocument, options);
      }
export type UpdateUserSocialSourceMutationHookResult = ReturnType<typeof useUpdateUserSocialSourceMutation>;
export type UpdateUserSocialSourceMutationResult = Apollo.MutationResult<UpdateUserSocialSourceMutation>;
export type UpdateUserSocialSourceMutationOptions = Apollo.BaseMutationOptions<UpdateUserSocialSourceMutation, UpdateUserSocialSourceMutationVariables>;
export const UpdateUserStatusFromAdminDocument = gql`
    mutation UpdateUserStatusFromAdmin($status: Float!, $userId: String!) {
  updateUserStatusFromAdmin(status: $status, userId: $userId) {
    createdAt
    email
    emailVerified
    fullName
    id
    isSubscribed {
      customerStripeId
    }
    isTPinAdded
    phoneNumber
    roles {
      createdAt
      id
      role
      updatedAt
    }
    status
    updatedAt
  }
}
    `;
export type UpdateUserStatusFromAdminMutationFn = Apollo.MutationFunction<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>;

/**
 * __useUpdateUserStatusFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusFromAdminMutation, { data, loading, error }] = useUpdateUserStatusFromAdminMutation({
 *   variables: {
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserStatusFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>(UpdateUserStatusFromAdminDocument, options);
      }
export type UpdateUserStatusFromAdminMutationHookResult = ReturnType<typeof useUpdateUserStatusFromAdminMutation>;
export type UpdateUserStatusFromAdminMutationResult = Apollo.MutationResult<UpdateUserStatusFromAdminMutation>;
export type UpdateUserStatusFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>;
export const FetchCustomerInvoicesDocument = gql`
    query FetchCustomerInvoices($customerInvoiceInput: InvoiceInput!) {
  fetchCustomerInvoices(customerInvoiceInput: $customerInvoiceInput) {
    data {
      account_country
      account_name
      amount_due
      amount_paid
      amount_remaining
      attempt_count
      billing_reason
      description
      charge {
        amount
        created
        description
        failure_code
        failure_message
        id
        object
        paid
        receipt_number
        receipt_url
        status
        payment_method_details {
          card {
            last4
            brand
          }
        }
      }
      created
      currency
      customer
      customer_email
      hosted_invoice_url
      id
      invoice_pdf
      number
      object
      paid
      period_end
      period_start
      status
      subtotal
      subtotal_excluding_tax
      total
      total_discount_amounts {
        amount
        discount
      }
    }
    has_more
    url
  }
}
    `;

/**
 * __useFetchCustomerInvoicesQuery__
 *
 * To run a query within a React component, call `useFetchCustomerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerInvoicesQuery({
 *   variables: {
 *      customerInvoiceInput: // value for 'customerInvoiceInput'
 *   },
 * });
 */
export function useFetchCustomerInvoicesQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>(FetchCustomerInvoicesDocument, options);
      }
export function useFetchCustomerInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>(FetchCustomerInvoicesDocument, options);
        }
export type FetchCustomerInvoicesQueryHookResult = ReturnType<typeof useFetchCustomerInvoicesQuery>;
export type FetchCustomerInvoicesLazyQueryHookResult = ReturnType<typeof useFetchCustomerInvoicesLazyQuery>;
export type FetchCustomerInvoicesQueryResult = Apollo.QueryResult<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>;
export const FetchCardDetailsDocument = gql`
    query FetchCardDetails($fetchCardDetailsInput: String!) {
  fetchCardDetails(fetchCardDetailsInput: $fetchCardDetailsInput) {
    address_line1
    address_line2
    address_state
    address_zip
    address_city
    address_country
    name
    exp_month
    exp_year
    last4
    brand
  }
}
    `;

/**
 * __useFetchCardDetailsQuery__
 *
 * To run a query within a React component, call `useFetchCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCardDetailsQuery({
 *   variables: {
 *      fetchCardDetailsInput: // value for 'fetchCardDetailsInput'
 *   },
 * });
 */
export function useFetchCardDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchCardDetailsQuery, FetchCardDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCardDetailsQuery, FetchCardDetailsQueryVariables>(FetchCardDetailsDocument, options);
      }
export function useFetchCardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCardDetailsQuery, FetchCardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCardDetailsQuery, FetchCardDetailsQueryVariables>(FetchCardDetailsDocument, options);
        }
export type FetchCardDetailsQueryHookResult = ReturnType<typeof useFetchCardDetailsQuery>;
export type FetchCardDetailsLazyQueryHookResult = ReturnType<typeof useFetchCardDetailsLazyQuery>;
export type FetchCardDetailsQueryResult = Apollo.QueryResult<FetchCardDetailsQuery, FetchCardDetailsQueryVariables>;
export const ChangeCardDocument = gql`
    mutation ChangeCard($changeCardInput: ChangeCardInput!) {
  changeCard(changeCardInput: $changeCardInput) {
    address_line1
    address_line2
    address_state
    address_zip
    address_city
    address_country
    name
    exp_month
    exp_year
    last4
    brand
  }
}
    `;
export type ChangeCardMutationFn = Apollo.MutationFunction<ChangeCardMutation, ChangeCardMutationVariables>;

/**
 * __useChangeCardMutation__
 *
 * To run a mutation, you first call `useChangeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCardMutation, { data, loading, error }] = useChangeCardMutation({
 *   variables: {
 *      changeCardInput: // value for 'changeCardInput'
 *   },
 * });
 */
export function useChangeCardMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCardMutation, ChangeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCardMutation, ChangeCardMutationVariables>(ChangeCardDocument, options);
      }
export type ChangeCardMutationHookResult = ReturnType<typeof useChangeCardMutation>;
export type ChangeCardMutationResult = Apollo.MutationResult<ChangeCardMutation>;
export type ChangeCardMutationOptions = Apollo.BaseMutationOptions<ChangeCardMutation, ChangeCardMutationVariables>;
export const FetchBillingDetailsDocument = gql`
    query fetchBillingDetails($fetchCardDetailsInput: String!) {
  fetchCardDetails(fetchCardDetailsInput: $fetchCardDetailsInput) {
    address_line1
    address_line2
    address_state
    address_zip
    address_city
    address_country
    customer_name
    name
    exp_month
    exp_year
    last4
    brand
  }
}
    `;

/**
 * __useFetchBillingDetailsQuery__
 *
 * To run a query within a React component, call `useFetchBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillingDetailsQuery({
 *   variables: {
 *      fetchCardDetailsInput: // value for 'fetchCardDetailsInput'
 *   },
 * });
 */
export function useFetchBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>(FetchBillingDetailsDocument, options);
      }
export function useFetchBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>(FetchBillingDetailsDocument, options);
        }
export type FetchBillingDetailsQueryHookResult = ReturnType<typeof useFetchBillingDetailsQuery>;
export type FetchBillingDetailsLazyQueryHookResult = ReturnType<typeof useFetchBillingDetailsLazyQuery>;
export type FetchBillingDetailsQueryResult = Apollo.QueryResult<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>;